import { redirect } from "@tanstack/react-router";

import type { RegisteredRouter, RouteById } from "@tanstack/react-router";

type AppContext = RouteById<RegisteredRouter["routeTree"], "/_app">["types"]["allContext"];

export function requireAdmin({ context }: { context: AppContext }) {
	if (context.user.user_type !== "admin") {
		redirect({ to: "/", throw: true });
	}
}
